import { TranslationKey } from './../../../../types/translation/TranslationKey';
import React, { useContext, useMemo, useState } from 'react';
import FlexPane from '../../../../VentoryUI/components/common/FlexPane';
import SearchBarWithFilter from '../../../../VentoryUI/components/common/SearchBarWithFilter';
import { t } from '../../../../types/translation/Translator';
import Table from '../../../components/Table';
import { ProductMasterDataContext } from '../../../../context/ProductMasterDataContext';
import { CompanyContext } from '../../../../context/CompanyContext';
import { UserContext } from '../../../../context/UserContext';
import { AssetTransactionContext } from '../../../../context/AssetTransactionContext';
import { AssetTransaction, AssetTransactionParentType } from '../../../../types/asset_transaction/assetTransaction';
import { AssetTransactionFilter } from '../../../../VentoryUI/components/filters/AssetTransactionFilter/AssetTransactionFilter';
import { AssetTransactionTable } from '../../Common/AssetTransactionTable';
import {
  AssetTransactionColumn,
  AssetTransactionTableSettings,
} from '../../../../types/asset_transaction/assetTransaction.table';
import { AssetTransactionUtil } from '../../../../types/asset_transaction/assetTransaction.util';
import { AssetContext } from '../../../../context/AssetContext';
import { CustomFieldContext } from '../../../../context/CustomFieldContext';
import { TagRelationContext } from '../../../../context/TagRelationContext';
import OwnershipAssetModal from '../Modals/OwnershipAssetModal';
import { TableSettingsContext } from '../../../../context/TableSettingsContext';
import { EntityType } from '../../../../types/comment';

export default function AssetOverviewHistoryPane() {
  const { currentCompany } = useContext(CompanyContext);
  const { productMasterData, productMasterDataLoading } = useContext(ProductMasterDataContext);
  const { assetTransactions, assetTransactionsLoading } = useContext(AssetTransactionContext);
  const { companyUsers, locale } = useContext(UserContext);
  const { assets } = useContext(AssetContext);
  const { getTableSettings } = useContext(TableSettingsContext);
  const { customFields } = useContext(CustomFieldContext);
  const { tagRelations } = useContext(TagRelationContext);

  const assetTableSettings = getTableSettings(EntityType.asset, currentCompany.id);

  const [open, setOpen] = useState<boolean>(false);
  const [selectedTransaction, setSelectedTransaction] = useState<AssetTransaction | undefined>(undefined);

  const items = useMemo(() => {
    return AssetTransactionUtil.groupByParent([...assetTransactions.values()]).sort(
      (a, b) => new Date(b.processedAt || b.createdAt).getTime() - new Date(a.processedAt || a.createdAt).getTime(),
    );
  }, [assetTransactions]);

  const [filteredItems, setFilteredItems] = useState<AssetTransaction[]>(items);

  const columns = [
    {
      index: 0,
      column: AssetTransactionColumn.productName,
      label: t(TranslationKey.assetName).singular.label,
    },
    {
      index: 1,
      column: AssetTransactionColumn.productNumber,
      label: t(TranslationKey.assetNumber).singular.label,
    },
    {
      index: 2,
      column: AssetTransactionColumn.serial,
      label: t(TranslationKey.serial).singular.label,
    },
    {
      index: 3,
      column: AssetTransactionColumn.createdAt,
      label: t(TranslationKey.createdAt).singular.label,
    },
    {
      index: 4,
      column: AssetTransactionColumn.signedAt,
      label: t(TranslationKey.signedAt).singular.label,
    },
    {
      index: 5,
      column: AssetTransactionColumn.assignedTo,
      label: t(TranslationKey.assignedTo).singular.label,
    },
    {
      index: 6,
      column: AssetTransactionColumn.status,
      label: t(TranslationKey.assetStatus).singular.label,
    },
    {
      index: 7,
      column: AssetTransactionColumn.quantity,
      label: t(TranslationKey.quantity).singular.label,
    },
  ];

  const filter = new AssetTransactionFilter(
    productMasterData,
    companyUsers,
    assets,
    assetTransactions,
    assetTableSettings,
    customFields,
    tagRelations,
    currentCompany,
  );

  return (
    <>
      {open && selectedTransaction && (
        <OwnershipAssetModal open={open} setOpen={setOpen} transaction={selectedTransaction} disabled={true} />
      )}

      <FlexPane
        header={
          <SearchBarWithFilter
            loading={assetTransactionsLoading || productMasterDataLoading}
            items={items}
            setItems={setFilteredItems}
            placeholder={t(TranslationKey.searchForAsset).plural.label}
            filter={filter}
          />
        }
        content={
          <Table
            loading={assetTransactionsLoading || productMasterDataLoading}
            items={filteredItems}
            totalItemCount={items.length}
            headers={AssetTransactionTable.header(
              productMasterData,
              companyUsers,
              currentCompany,
              new AssetTransactionTableSettings({ companyId: currentCompany.id, columns: columns }),
              locale,
            )}
            filter={filter}
            onClick={item => {
              if (item.parentType === AssetTransactionParentType.ownership) {
                console.log(item);
                setSelectedTransaction(item);
                setOpen(true);
              }
            }}
          />
        }
      />
    </>
  );
}
